import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { usePublicDemo } from "../context/PublicDemoContext";

const LoadingState = () => (
  <div className="min-h-screen trubeaute-gradient flex items-center justify-center">
    <div className="h-10 w-10 rounded-full border-2 border-[#EADDD7] border-t-[#9B6A6C] animate-spin" />
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { isDemoMode, demoBootstrapping } = usePublicDemo();
  const location = useLocation();

  if (loading) return <LoadingState />;
  // In public demo mode we auto-mint a demo user on first mount.
  // AuthContext.loading flips to false BEFORE that mint completes,
  // creating a brief `!user && !loading` window that would otherwise
  // trip the /login redirect and immediately re-redirect to `/`
  // (since /login also redirects home in demo mode). Show the
  // loading spinner during that window so the demo user has time
  // to arrive.
  if (isDemoMode && !user && demoBootstrapping) return <LoadingState />;
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  return children;
};

export default ProtectedRoute;
